"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const types_1 = require("../../../loading/types");
const actions_1 = require("../defaultFasteners/actions");
const actionCreators = __importStar(require("./actions"));
const consts_1 = require("./consts");
const bomFeedbackMessages = {
    [consts_1.REQUEST_SOCKET_ADD_ITEMS_TO_BOM]: 'bom.feedback-items',
    [consts_1.REQUEST_SOCKET_UPDATE_ITEMS_TO_BOM]: 'bom.feedback-items',
    [consts_1.REQUEST_SOCKET_REMOVE_ITEMS_FROM_BOM]: 'bom.feedback-items',
    [consts_1.REQUEST_SOCKET_ADD_FASTENERS_TO_BOM]: 'bom.feedback-fasteners',
    [consts_1.REQUEST_SOCKET_UPDATE_FASTENERS_TO_BOM]: 'bom.feedback-fasteners',
    [consts_1.REQUEST_SOCKET_ADD_SERVICES_TO_BOM]: 'bom.feedback-machining-services',
    [consts_1.REQUEST_SOCKET_UPDATE_SERVICES_TO_BOM]: 'bom.feedback-machining-services',
    [consts_1.REQUEST_SOCKET_REMOVE_SERVICES_FROM_BOM]: 'bom.feedback-machining-services',
    [consts_1.SET_ASSEMBLY_CHARGE_INCLUDED]: 'bom.feedback-assembly-charge',
    [consts_1.SET_ASSEMBLY_CHARGE_INCLUDED_ITEM]: 'bom.feedback-assembly-charge',
    [consts_1.REQUEST_SOCKET_BOM]: 'bom.feedback-calculating',
};
const initialState = {
    isLoading: types_1.LOADING_STATE.COMPLETE,
    bom: null,
    isQuoteShown: false,
    editMode: false,
    manuallyAddedItems: {},
    manuallyAddedMachiningServices: {},
    manuallyDeletedMachiningServices: {},
    manuallyDeletedItems: {},
    manuallyItemsQuantity: {},
    manuallyAddedMachiningServicesQuantity: {},
    manuallyItemsSize: {},
    countRequest: 0,
    awaitingCopyPasteFasteners: false,
    isBomSubmitDisabled: false,
    isDiscountedPriceShown: false,
    isExporting: false,
    bomNeedsRecalculation: false,
    feedback: null,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    var _a, _b, _c, _d, _e, _f;
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.requestSocketBOM): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.countRequest++;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestBOMSuccess): {
            draft.countRequest--;
            if (draft.countRequest <= 0) {
                draft.bom = action.payload;
                draft.bomNeedsRecalculation = false;
                draft.isLoading = types_1.LOADING_STATE.COMPLETE;
                draft.countRequest = 0;
                if (!((_a = draft.feedback) === null || _a === void 0 ? void 0 : _a.failed)) {
                    draft.feedback = null;
                }
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestBOMFail): {
            draft.bom = null;
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            draft.countRequest--;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setBOMFeedback): {
            if (((_b = draft.feedback) === null || _b === void 0 ? void 0 : _b.failed) && action.payload.actionType === consts_1.REQUEST_SOCKET_BOM) {
                return;
            }
            const message = action.payload.failed
                ? 'bom.update-failed'
                : bomFeedbackMessages[(_c = action.payload.actionType) !== null && _c !== void 0 ? _c : ''];
            if (!message) {
                return;
            }
            draft.feedback = { projectId: action.payload.projectId, message, failed: action.payload.failed };
            if (action.payload.failed) {
                draft.isLoading = types_1.LOADING_STATE.FAILED;
                draft.countRequest = 0;
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.openAiWindow): {
            draft.bomNeedsRecalculation = true;
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.countRequest = 0;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestRecalculateBOM): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setBomNeedsRecalculation): {
            draft.bomNeedsRecalculation = action.payload;
            if (action.payload && draft.isLoading !== types_1.LOADING_STATE.LOADING) {
                // AI has placed objects; clear any in-flight loading state so the
                // button shows "Recalculate BOM" instead of a spinner.
                draft.isLoading = types_1.LOADING_STATE.COMPLETE;
                draft.countRequest = 0;
                draft.feedback = null;
                draft.awaitingCopyPasteFasteners = false;
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setBOMLoading): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setBomSubmitDisabled): {
            draft.isBomSubmitDisabled = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestAddItemsToBOM): {
            if (draft.bomNeedsRecalculation) {
                return;
            }
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.countRequest++;
            draft.isBomSubmitDisabled = false;
            // When copy-pasting assemblies that have fasteners, the DefaultFastenerWidget
            // will asynchronously dispatch requestAddFastenersToBOM (which triggers another
            // BOM calculation). Pre-increment countRequest so the spinner stays visible
            // until the final BOM result arrives, instead of briefly hiding after the
            // first (intermediate) BOM response. The flag ensures the NEXT
            // requestAddFastenersToBOM skips its own increment (avoiding double-counting).
            const items = action.payload;
            const hasCopyPasteFasteners = items.some((item) => { var _a; return item.isCopyPaste && ((_a = item.connections) === null || _a === void 0 ? void 0 : _a.some((conn) => conn.numberOfFasteners && conn.numberOfFasteners > 0)); });
            if (hasCopyPasteFasteners) {
                draft.countRequest++;
                draft.awaitingCopyPasteFasteners = true;
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actions_1.requestFastenersExistenceSuccess): {
            if (draft.bomNeedsRecalculation) {
                return;
            }
            const expectsFastenerUpdate = action.payload.some(({ hasFasteners, itemNumber }) => hasFasteners && itemNumber !== undefined);
            if (expectsFastenerUpdate) {
                if (draft.awaitingCopyPasteFasteners) {
                    draft.awaitingCopyPasteFasteners = false;
                }
                else {
                    draft.countRequest++;
                }
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestAddFastenersToBOM): {
            if (draft.bomNeedsRecalculation) {
                return;
            }
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.isBomSubmitDisabled = false;
            // If this is the first fastener request after a copy-paste, the
            // countRequest was already pre-incremented — skip the increment.
            if (draft.awaitingCopyPasteFasteners) {
                draft.awaitingCopyPasteFasteners = false;
            }
            else {
                draft.countRequest++;
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestRemoveItemsFromBOM):
        case (0, typesafe_actions_1.getType)(actionCreators.requestUpdateItemsToBOM): {
            if (draft.bomNeedsRecalculation) {
                return;
            }
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.countRequest++;
            draft.isBomSubmitDisabled = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestAddServicesToBOM):
        case (0, typesafe_actions_1.getType)(actionCreators.requestRemoveServicesFromBOM):
        case (0, typesafe_actions_1.getType)(actionCreators.requestUpdateServicesToBOM): {
            if (draft.bomNeedsRecalculation) {
                return;
            }
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.countRequest++;
            draft.isBomSubmitDisabled = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestCloseProject): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            draft.countRequest = 0;
            draft.awaitingCopyPasteFasteners = false;
            draft.isBomSubmitDisabled = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setDefaultBOM): {
            draft.bom = null;
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.countRequest = 0;
            draft.awaitingCopyPasteFasteners = false;
            draft.isBomSubmitDisabled = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setEmptyBOM): {
            draft.bom = null;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.toggleQuote): {
            draft.isQuoteShown = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.editMode): {
            draft.editMode = action.payload;
            if (!action.payload) {
                draft.manuallyAddedItems = {};
                draft.manuallyDeletedItems = {};
                draft.manuallyItemsQuantity = {};
                draft.manuallyAddedMachiningServices = {};
                draft.manuallyDeletedMachiningServices = {};
                draft.manuallyAddedMachiningServicesQuantity = {};
                draft.manuallyItemsSize = {};
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addManually): {
            draft.manuallyAddedItems[action.payload.uuid && action.payload.uuid.length > 0 ? action.payload.uuid[0] : action.payload.item_number] = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addManuallyDeleted): {
            draft.manuallyDeletedItems[action.payload.uuid && action.payload.uuid.length > 0 ? action.payload.uuid[0] : action.payload.item_number] = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addItemQuantity): {
            draft.manuallyItemsQuantity[action.payload.uuid] = action.payload.value;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addItemSize): {
            draft.manuallyItemsSize[action.payload.uuid] = action.payload.value;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.deleteManuallyAdded): {
            delete draft.manuallyAddedItems[action.payload];
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.applyMachiningServiceManually): {
            const key = action.payload.projectItemUUID;
            if (Object.hasOwn(draft.manuallyAddedMachiningServices, key)) {
                draft.manuallyAddedMachiningServices[key].push(action.payload);
            }
            else {
                draft.manuallyAddedMachiningServices[key] = [action.payload];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addManuallyDeletedMachiningService): {
            const key = action.payload.projectItemUUID;
            if (Object.hasOwn(draft.manuallyDeletedMachiningServices, key)) {
                draft.manuallyDeletedMachiningServices[key].push(action.payload);
            }
            else {
                draft.manuallyDeletedMachiningServices[key] = [action.payload];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.deleteManuallyAddedMachiningService): {
            const key = action.payload.projectItemUUID;
            draft.manuallyAddedMachiningServices[key] = draft.manuallyAddedMachiningServices[key].filter((service) => service.machiningServiceId !== action.payload.machiningServiceId);
            if (draft.manuallyAddedMachiningServices[key].length === 0) {
                delete draft.manuallyAddedMachiningServices[key];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.addManuallyAddedMachiningServiceQuantity): {
            const key = action.payload.projectItemUUID;
            if (Object.hasOwn(draft.manuallyAddedMachiningServicesQuantity, key)) {
                draft.manuallyAddedMachiningServicesQuantity[key].push(action.payload);
            }
            else {
                draft.manuallyAddedMachiningServicesQuantity[key] = [action.payload];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.toggleAssemblyChargeForItem): {
            const targetItem = (_f = (_e = (_d = draft.bom) === null || _d === void 0 ? void 0 : _d.assemblyCharge) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.find((item) => item.id === action.payload.id);
            if (targetItem) {
                targetItem.isAssemblyChargeIncluded = action.payload.isAssemblyChargeIncluded;
            }
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setDiscountedPriceShown): {
            draft.isDiscountedPriceShown = action.payload;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setBOMExporting): {
            draft.isExporting = action.payload;
            break;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
